import { AboutService } from './about/about.service';

export const APP_PROVIDERS: Array<any> = [
  AboutService
];



// WEBPACK FOOTER //
// ./src/app/app.providers.ts